// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay (Fondo oscuro que va por detras del modal) */
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.2s;
    backdrop-filter: blur(2px);
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

/* Contenedor del Modal */
.modal-content {
    background: var(--bg-card); /* Blanco en luz, Gris oscuro en dark */
    color: var(--texto-principal);
    border-radius: 12px;
    width: 90%;
    max-width: 550px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: var(--sombra-card);
    margin: 20px;
    border: 1px solid var(--color-borders);
}

/* Header */
.modal-header {
    padding: 20px 25px;
    border-bottom: 1px solid var(--color-borders);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-title { 
    margin: 0; 
    font-size: 1.3rem; 
    font-weight: 700; 
    color: var(--texto-principal); 
}

.btn-close-modal {
    background: none;
    border: none;
    font-size: 1.6rem;
    cursor: pointer;
    color: var(--color-gray-text);
    padding: 4px;
    border-radius: 6px;
    display: flex;
    transition: background-color 0.2s;
}

.btn-close-modal:hover { 
    background-color: var(--color-light-bg); 
    color: var(--texto-principal); 
}

/* Body con scroll */
.modal-body { 
    padding: 25px; 
    overflow-y: auto; 
    flex: 1 1; 
}

/* Footer con botones */
.modal-footer {
    padding: 20px 25px;
    border-top: 1px solid var(--color-borders);
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background-color: var(--color-light-bg);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}

/* Formularios */
.form-group { margin-bottom: 18px; }

.form-label { 
    display: block; 
    margin-bottom: 8px; 
    font-weight: 600; 
    color: var(--texto-principal); 
    font-size: 0.95rem; 
}

.form-input, .form-select { 
    width: 100%; 
    padding: 12px; 
    
    border: 1px solid var(--color-borders); 
    background-color: var(--bg-input); 
    color: var(--texto-principal);
    
    border-radius: 8px; 
    font-size: 1rem; 
    outline: none; 
    transition: all 0.2s; 
}

.form-input:focus, .form-select:focus { 
    border-color: var(--primary-blue); 
    box-shadow: 0 0 0 3px rgba(80, 56, 237, 0.15); 
}

/* Estados de Error */
.input-error { 
    border-color: var(--score-rojo) !important; 
    background-color: rgba(239, 68, 68, 0.05);
}

.input-error:focus { 
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1); 
}

.error-msg { 
    display: block; 
    color: var(--score-rojo); 
    font-size: 0.85rem; 
    margin-top: 6px; 
    font-weight: 500; 
}

/* Botones */
.btn-cancel, .btn-submit, .btn-confirm-delete { 
    padding: 10px 20px; 
    border-radius: 8px; 
    border: none; 
    font-weight: 600; 
    font-size: 1rem; 
    cursor: pointer; 
    transition: all 0.2s; 
}

.btn-cancel { 
    background: var(--bg-card); 
    color: var(--texto-principal); 
    border: 1px solid var(--color-borders); 
}

.btn-cancel:hover { 
    background: var(--color-light-bg); 
    border-color: var(--color-gray-text); 
}

.btn-submit { 
    background: var(--primary-blue); 
    color: white; 
}

.btn-submit:hover { 
    opacity: 0.9;
    box-shadow: 0 4px 12px rgba(80, 56, 237, 0.3); 
}

.btn-confirm-delete { 
    background: var(--score-rojo); 
    color: white; 
}

.btn-confirm-delete:hover { 
    background: #dc2626; 
}

.modal-confirm { 
    max-width: 480px; 
    max-height: auto; 
}

.confirm-message { 
    font-size: 1.1rem; 
    margin-bottom: 15px; 
    line-height: 1.5; 
    color: var(--texto-principal);
}

.confirm-warning { 
    background-color: rgba(254, 242, 242, 1); /* Mantenemos rojizo claro por alerta */
    border-left: 4px solid var(--score-rojo); 
    padding: 12px; 
    color: #b91c1c; 
    border-radius: 4px; 
    font-size: 0.95rem; 
}

/* Ajuste dark mode para el warning box si se desea */
body.dark-mode .confirm-warning {
    background-color: rgba(239, 68, 68, 0.1);
    color: #fca5a5;
}

@media (max-width: 768px) {
    .modal-content {
        max-height: 90vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ModalProductos/modalProductos.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;IACI,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE5D,yBAAyB;AACzB;IACI,0BAA0B,EAAE,uCAAuC;IACnE,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,sCAAsC;AAC1C;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;IACvC,6BAA6B;AACjC;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,gBAAgB;IAChB,SAAO;AACX;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,uCAAuC;IACvC,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA,gBAAgB;AAChB,cAAc,mBAAmB,EAAE;;AAEnC;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;;IAEb,sCAAsC;IACtC,iCAAiC;IACjC,6BAA6B;;IAE7B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,6CAA6C;AACjD;;AAEA,qBAAqB;AACrB;IACI,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,wCAAwC,EAAE,uCAAuC;IACjF,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,qDAAqD;AACrD;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* Overlay (Fondo oscuro que va por detras del modal) */\r\n.modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0,0,0,0.6);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    animation: fadeIn 0.2s;\r\n    backdrop-filter: blur(2px);\r\n}\r\n\r\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\r\n\r\n/* Contenedor del Modal */\r\n.modal-content {\r\n    background: var(--bg-card); /* Blanco en luz, Gris oscuro en dark */\r\n    color: var(--texto-principal);\r\n    border-radius: 12px;\r\n    width: 90%;\r\n    max-width: 550px;\r\n    max-height: 85vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: var(--sombra-card);\r\n    margin: 20px;\r\n    border: 1px solid var(--color-borders);\r\n}\r\n\r\n/* Header */\r\n.modal-header {\r\n    padding: 20px 25px;\r\n    border-bottom: 1px solid var(--color-borders);\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.modal-title { \r\n    margin: 0; \r\n    font-size: 1.3rem; \r\n    font-weight: 700; \r\n    color: var(--texto-principal); \r\n}\r\n\r\n.btn-close-modal {\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.6rem;\r\n    cursor: pointer;\r\n    color: var(--color-gray-text);\r\n    padding: 4px;\r\n    border-radius: 6px;\r\n    display: flex;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.btn-close-modal:hover { \r\n    background-color: var(--color-light-bg); \r\n    color: var(--texto-principal); \r\n}\r\n\r\n/* Body con scroll */\r\n.modal-body { \r\n    padding: 25px; \r\n    overflow-y: auto; \r\n    flex: 1; \r\n}\r\n\r\n/* Footer con botones */\r\n.modal-footer {\r\n    padding: 20px 25px;\r\n    border-top: 1px solid var(--color-borders);\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 12px;\r\n    background-color: var(--color-light-bg);\r\n    border-bottom-left-radius: 12px;\r\n    border-bottom-right-radius: 12px;\r\n}\r\n\r\n/* Formularios */\r\n.form-group { margin-bottom: 18px; }\r\n\r\n.form-label { \r\n    display: block; \r\n    margin-bottom: 8px; \r\n    font-weight: 600; \r\n    color: var(--texto-principal); \r\n    font-size: 0.95rem; \r\n}\r\n\r\n.form-input, .form-select { \r\n    width: 100%; \r\n    padding: 12px; \r\n    \r\n    border: 1px solid var(--color-borders); \r\n    background-color: var(--bg-input); \r\n    color: var(--texto-principal);\r\n    \r\n    border-radius: 8px; \r\n    font-size: 1rem; \r\n    outline: none; \r\n    transition: all 0.2s; \r\n}\r\n\r\n.form-input:focus, .form-select:focus { \r\n    border-color: var(--primary-blue); \r\n    box-shadow: 0 0 0 3px rgba(80, 56, 237, 0.15); \r\n}\r\n\r\n/* Estados de Error */\r\n.input-error { \r\n    border-color: var(--score-rojo) !important; \r\n    background-color: rgba(239, 68, 68, 0.05);\r\n}\r\n\r\n.input-error:focus { \r\n    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1); \r\n}\r\n\r\n.error-msg { \r\n    display: block; \r\n    color: var(--score-rojo); \r\n    font-size: 0.85rem; \r\n    margin-top: 6px; \r\n    font-weight: 500; \r\n}\r\n\r\n/* Botones */\r\n.btn-cancel, .btn-submit, .btn-confirm-delete { \r\n    padding: 10px 20px; \r\n    border-radius: 8px; \r\n    border: none; \r\n    font-weight: 600; \r\n    font-size: 1rem; \r\n    cursor: pointer; \r\n    transition: all 0.2s; \r\n}\r\n\r\n.btn-cancel { \r\n    background: var(--bg-card); \r\n    color: var(--texto-principal); \r\n    border: 1px solid var(--color-borders); \r\n}\r\n\r\n.btn-cancel:hover { \r\n    background: var(--color-light-bg); \r\n    border-color: var(--color-gray-text); \r\n}\r\n\r\n.btn-submit { \r\n    background: var(--primary-blue); \r\n    color: white; \r\n}\r\n\r\n.btn-submit:hover { \r\n    opacity: 0.9;\r\n    box-shadow: 0 4px 12px rgba(80, 56, 237, 0.3); \r\n}\r\n\r\n.btn-confirm-delete { \r\n    background: var(--score-rojo); \r\n    color: white; \r\n}\r\n\r\n.btn-confirm-delete:hover { \r\n    background: #dc2626; \r\n}\r\n\r\n.modal-confirm { \r\n    max-width: 480px; \r\n    max-height: auto; \r\n}\r\n\r\n.confirm-message { \r\n    font-size: 1.1rem; \r\n    margin-bottom: 15px; \r\n    line-height: 1.5; \r\n    color: var(--texto-principal);\r\n}\r\n\r\n.confirm-warning { \r\n    background-color: rgba(254, 242, 242, 1); /* Mantenemos rojizo claro por alerta */\r\n    border-left: 4px solid var(--score-rojo); \r\n    padding: 12px; \r\n    color: #b91c1c; \r\n    border-radius: 4px; \r\n    font-size: 0.95rem; \r\n}\r\n\r\n/* Ajuste dark mode para el warning box si se desea */\r\nbody.dark-mode .confirm-warning {\r\n    background-color: rgba(239, 68, 68, 0.1);\r\n    color: #fca5a5;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .modal-content {\r\n        max-height: 90vh;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
